var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var Editor2DModel = require("./../../editor2D/editor2DModel.js");
var DrawingStateMachine = require("./../../../abstract/stateMachines/drawingStateMachine.js");

var EllipseToolStateMachine = function (root, editorModel, selectionModel, getDataCollection, options) {
    this.root = root;
    this.getDataCollection = getDataCollection;
    this.options = options;

    DrawingStateMachine.call(this, root, editorModel, selectionModel);
};

lib_core.inherit(EllipseToolStateMachine, DrawingStateMachine);

module.exports = EllipseToolStateMachine;

EllipseToolStateMachine.prototype.createElement = function () {
    var ellipse = new cio_datamodel.EllipseData(this.startCoord,
            this.options.angle, 0, 0,
            this.options.fill, this.options.strokeWidth);

    ellipse.addTo(this.getDataCollection());

    return this.getElementInteractionModel(ellipse);
};

EllipseToolStateMachine.prototype.setElement = function (startCoord, currentCoord, keys) {
    var minSide;

    if (keys.altKey === false && keys.shiftKey === false ) {

        this.element.pos(startCoord.add(currentCoord).mult(0.5));

        this.element.width(Math.abs(startCoord.x-currentCoord.x));
        this.element.height(Math.abs(startCoord.y-currentCoord.y));
    } else if (keys.altKey === true && keys.shiftKey === false) {

        this.element.pos(startCoord);

        this.element.width(2 * Math.abs(startCoord.x-currentCoord.x));
        this.element.height(2 * Math.abs(startCoord.y-currentCoord.y));
    } else if (keys.altKey === false && keys.shiftKey === true) {

        minSide = Math.min(Math.abs(startCoord.x-currentCoord.x), Math.abs(startCoord.y-currentCoord.y));

        var deltaVec = currentCoord.sub(startCoord);

        var center = startCoord.copy();

        if (deltaVec.x >= 0) {
            center.x += minSide/2;
        } else {
            center.x -= minSide/2;
        }

        if (deltaVec.y >= 0) {
            center.y += minSide/2;
        } else {
            center.y -= minSide/2;
        }

        this.element.pos(center);

        this.element.width(minSide);
        this.element.height(minSide);

    } else if (keys.altKey === true && keys.shiftKey === true) {

        this.element.pos(startCoord);

        minSide = Math.min(Math.abs(startCoord.x-currentCoord.x), Math.abs(startCoord.y-currentCoord.y));

        this.element.width(2 * minSide);
        this.element.height(2 * minSide);

    }

};
